__webpack_require__.p = "/dev/761-au-shift-click-sur-le-score-le-curseur-ne-se-positionne-pas/";